module.exports = __webpack_public_path__ + "img/322.d4fa09db.png";